import type { GatewayCustomerService } from 'commonTypes/api/gatewayCustomerService';

export type TScoresQueryData = Omit<GatewayCustomerService.TScoresQueryRequest, 'userId' | 'channel'>;

const REQUIRED_SCORES_QUERY_FIELDS: Array<keyof TScoresQueryData> = [
  'phone',
  'email',
  'firstName',
  'lastName',
  'birthDate',
  'birthPlace',
  'passportSerial',
  'passportNumber',
  'passportIssueDate',
  'passportIssuedBy',
  'unitCode',
  'residenceAddress',
  'registrationAddress',
];

export const createScoresQueryData = (queryData: Partial<TScoresQueryData>): TScoresQueryData => {
  return {
    phone: queryData.phone || '',
    email: queryData.email || '',
    firstName: queryData.firstName || '',
    lastName: queryData.lastName || '',
    middleName: queryData.middleName || undefined,
    birthDate: queryData.birthDate || '',
    birthPlace: queryData.birthPlace || '',
    passportSerial: queryData.passportSerial || '',
    passportNumber: queryData.passportNumber || '',
    passportIssueDate: queryData.passportIssueDate || '',
    passportIssuedBy: queryData.passportIssuedBy || '',
    unitCode: queryData.unitCode || '',
    residenceAddress: queryData.residenceAddress || '',
    registrationAddress: queryData.registrationAddress || '',
    isResidenceAddressMatch: Boolean(queryData.isResidenceAddressMatch),
  };
};

export const isScoresQueryDataReady = (queryData: TScoresQueryData) => {
  return REQUIRED_SCORES_QUERY_FIELDS.every((field) => Boolean(queryData[field]));
};
